// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Wftx","productName":"Table_productName__nfL3Y"};